var map = {
	"./demo/logo-full.png": "eadc",
	"./demo/logo-full_lugano.png": "c3af",
	"./demo/logo-full_milano.png": "cd13",
	"./demo/logo.png": "9c2a",
	"./odb/logo-full_demo.png": "f6a4",
	"./odb/logo-full_lugano.png": "784d",
	"./odb/logo-full_milano.png": "02a2",
	"./odb/logo.png": "94a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "818c";